import { render, staticRenderFns } from "./resalst.vue?vue&type=template&id=8e595b7a&"
import script from "./resalst.vue?vue&type=script&lang=js&"
export * from "./resalst.vue?vue&type=script&lang=js&"
import style0 from "./resalst.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports